import React from "react";
import CheckboxGroup from "../../CheckboxGroup";
import { useIntl } from "react-intl";

export function SelectRoleNames({ roleNames, scopes, setScopes }) {
  const intl = useIntl();
  const elements = ["public"].concat(roleNames.map((i) => i.name));
  return (
    <div>
      <CheckboxGroup
        labelClasses="font-bold"
        options={elements.map((o) => ({
          value: o,
          name: intl.formatMessage({ id: o }),
        }))}
        values={scopes}
        onChange={(value) => {
          if (scopes.indexOf(value) >= 0) {
            setScopes([...scopes.filter((v) => v !== value)]);
          } else {
            setScopes([...scopes, value]);
          }
        }}
      />
    </div>
  );
}
export function SelectGroupNames({ groupNames, scopes, setScopes }) {
  const elements = groupNames.map((i) => i.name);
  return (
    <>
      {elements.length > 0 ? (
        <div>
          <CheckboxGroup
            labelClasses="font-bold"
            options={elements.map((o) => ({
              value: "group_" + o,
              name: o,
            }))}
            values={scopes}
            onChange={(value) => {
              if (scopes.indexOf(value) >= 0) {
                setScopes([...scopes.filter((v) => v !== value)]);
              } else {
                setScopes([...scopes, value]);
              }
            }}
          />
        </div>
      ) : null}
    </>
  );
}
